module.exports = __webpack_public_path__ + "img/swift.4c7f5fbe.png";